import { bookType } from '@/models/Book';
import { buildLessonUrl, LessonUrlParams } from '@/utils/lessonUrlBuilder';
import { mapTypeToRoute } from './bookAdapters';

type MaterialIdParam = number | string;

export type MaterialUrlParams = LessonUrlParams & {
  bookType: bookType;
  bookId: MaterialIdParam;
  chapterId?: MaterialIdParam;
};

export const buildMaterialUrl = ({
  lessonId,
  bookType,
  bookId,
  slugCourseName,
  blockId,
  chapterId,
}: MaterialUrlParams): string => {
  const bookEndpoint = mapTypeToRoute[bookType];
  const lessonBase = buildLessonUrl({ lessonId, slugCourseName, blockId });
  const chapterSegment = chapterId ? `/chapter/${chapterId}` : '';

  return `/admin/${lessonBase}${bookEndpoint}/${bookId}${chapterSegment}`;
};
